module.exports = __webpack_public_path__ + "img/b6-3.0f2b80a.png";